import { defineCatalogue } from '../../../../i18n';

export const catalogueCardCatalogue = defineCatalogue(
  {
    'kind.POST': 'Publicações',
    'kind.REEL': 'Reels',
    'kind.STORY': 'Stories',
    'kind.AUDIO': 'Áudio',
  },
  {
    'kind.POST': 'Posts',
    'kind.REEL': 'Reels',
    'kind.STORY': 'Stories',
    'kind.AUDIO': 'Audio',
  },
);

export const ctt = catalogueCardCatalogue.t;
